/* eslint-disable no-mixed-spaces-and-tabs */
import { createSelector } from 'reselect';
import isEmpty from 'lodash/isEmpty';
import { initialState } from './reducer';

export const selectRatesDictionaryDomain = state => state.ratesDictionaryReducer || initialState;
export const selectRouterDomain = state => state.router || {};

export const getIsDictionaryDataLoadingSelector = () =>
	createSelector(selectRatesDictionaryDomain, ({ isDictionaryDataLoading }) => isDictionaryDataLoading);

export const getDictionaryDataSelector = () =>
	createSelector(selectRatesDictionaryDomain, ({ dictionaryData }) => {
		if (!dictionaryData || dictionaryData.length === 0) {
			return [];
		}

		return dictionaryData;
	});

export const getIsModalShownSelector = () =>
	createSelector(selectRouterDomain, ({ location: { query } }) => {
		return Boolean(!isEmpty(query) && query?.modal === 'rates');
	});
